import React, { useState } from 'react';
import Select, { components as selectComponents } from 'react-select';
import { useSelector } from 'react-redux';
import { MultipleValuesContainer as MultiValue } from './MultiValueComponent';
import './select.scss';
import { selectStyles } from './selectStyles';

const AutoSuggestionSelectComponent = (props) => {
  const themeColors = useSelector((state) => state.theme.themeValuesObject);
  const { inputClassName, components, ...otherProps } = props;
  const [selectClassName, setSelectClassName] = useState('');
  const customStyles = selectStyles({ themeColors });

  const Input = (props) => (
    <selectComponents.Input
      {...props}
      maxLength={50}
      autoFocus={selectClassName && true}
    />
  );
  const defaultComponents = { MultiValue, Input, MultiValueRemove: () => null };
  return (
    <Select
      {...otherProps}
      styles={customStyles}
      className={`generic-select ${inputClassName || ''} ${selectClassName}`}
      onFocus={() => setSelectClassName('select-focus-border-admin')}
      onBlur={() => setSelectClassName('')}
      components={
        components ? { ...defaultComponents, ...components } : defaultComponents
      }
      isClearable={props.isMulti}
      hideSelectedOptions={false}
      classNamePrefix={'generic-select-prefix'}
      isMenuOpen={true}
      isOptionDisabled={(option) => option.isdisabled}
    />
  );
};

export default AutoSuggestionSelectComponent;
